import { render, staticRenderFns } from "./LoginCode.vue?vue&type=template&id=66e06e33"
import script from "./LoginCode.vue?vue&type=script&lang=js"
export * from "./LoginCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports